import React from "react";
import { Link } from "react-router-dom";
import Chart from "react-apexcharts";
import { all_routes } from "../../../Router/all_routes";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";

const ApplicantTracking = () => {
  const route = all_routes;

  const salesDayChart = {
    chart: {
      height: 245,
      type: "bar",
      stacked: true,
      toolbar: {
        show: false,
      },
    },
    colors: ["#FE9F43", "#FFE3CB"],
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: "bottom",
            offsetX: -10,
            offsetY: 0,
          },
        },
      },
    ],
    plotOptions: {
      bar: {
        borderRadius: 8,
        borderRadiusWhenStacked: "all",
        horizontal: false,
        endingShape: "rounded",
      },
    },
    series: [
      {
        name: "Hired",
        data: [18, 20, 10, 18, 25, 18, 10, 20, 40, 8, 30, 20],
      },
      {
        name: "Jobs Posted",
        data: [40, 30, 30, 50, 40, 50, 30, 30, 50, 30, 40, 30],
      },
    ],
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      labels: {
        style: {
          colors: "#6B7280",
          fontSize: "13px",
        },
      },
    },
    yaxis: {
      labels: {
        formatter: (val) => `${val}K`,
        offsetX: -15,
        style: {
          colors: "#6B7280",
          fontSize: "13px",
        },
      },
    },
    grid: {
      borderColor: "#E5E7EB",
      strokeDashArray: 5,
      padding: {
        left: -16,
        top: 0,
        bottom: 0,
        right: 0,
      },
    },
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    fill: {
      opacity: 1,
    },
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-2">
          <div className="mb-3">
            <h1 className="mb-1">Applicant Tracking</h1>
            <p className="fw-medium">
              You have <span className="text-primary fw-bold">200+</span>
              New Applicants, Today
            </p>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-3 col-sm-6 col-12 d-flex">
            <Link
              to={route.applicanttrackingjobsPosting}
              className="card bg-secondary sale-widget flex-fill"
            >
              <div className="card-body d-flex align-items-center">
                <span className="sale-icon bg-white text-secondary">
                  <i className="bi bi-send-check fs-2" />
                </span>
                <div className="ms-2">
                  <p className="text-white mb-1">Jobs Posted</p>
                  <div className="d-inline-flex align-items-center flex-wrap gap-2">
                    <h4 className="text-white">478,145</h4>
                    {/* <span className="badge badge-soft-danger">
                      <i className="ti ti-arrow-down me-1" />
                      -22%
                    </span> */}
                  </div>
                </div>
              </div>
            </Link>
          </div>
          <div className="col-xl-3 col-sm-6 col-12 d-flex">
            <Link
              to={route.applicanttrackingapplicants}
              className="card bg-primary sale-widget flex-fill"
            >
              <div className="card-body d-flex align-items-center">
                <span className="sale-icon bg-white text-primary">
                  <i className="bi bi-person-add fs-2" />
                </span>
                <div className="ms-2">
                  <p className="text-white mb-1">Applicants</p>
                  <div className="d-inline-flex align-items-center flex-wrap gap-2">
                    <h4 className="text-white">988,078</h4>
                    {/* <span className="badge badge-soft-primary">
                      <i className="ti ti-arrow-up me-1" />
                      +22%
                    </span> */}
                  </div>
                </div>
              </div>
            </Link>
          </div>

          <div className="col-xl-3 col-sm-6 col-12 d-flex">
            <Link
              to={route.applicanttrackingclients}
              className="card bg-teal sale-widget flex-fill"
            >
              <div className="card-body d-flex align-items-center">
                <span className="sale-icon bg-white text-teal">
                  <i className="bi bi-person-vcard fs-2" />
                </span>
                <div className="ms-2">
                  <p className="text-white mb-1">Clients</p>
                  <div className="d-inline-flex align-items-center flex-wrap gap-2">
                    <h4 className="text-white">145,789</h4>
                    {/* <span className="badge badge-soft-success">
                      <i className="ti ti-arrow-up me-1" />
                      +22%
                    </span> */}
                  </div>
                </div>
              </div>
            </Link>
          </div>
          <div className="col-xl-3 col-sm-6 col-12 d-flex">
            <div className="card bg-info sale-widget flex-fill">
              <div className="card-body d-flex align-items-center">
                {/* <span className="sale-icon bg-white text-info">
                  <i className="ti ti-brand-pocket fs-24" />
                </span> */}
                <span className="sale-icon bg-white text-info">
                  <i className="bi bi-calendar2-check fs-2" />
                </span>
                <div className="ms-2">
                  <p className="text-white mb-1">Interview Scheduled</p>
                  <div className="d-inline-flex align-items-center flex-wrap gap-2">
                    <h4 className="text-white">358,747</h4>
                    {/* <span className="badge badge-soft-success">
                      <i className="ti ti-calendar me-1" />
                      +22%
                    </span> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xxl-8 col-xl-6 col-sm-12 col-12 d-flex">
            <div className="card flex-fill">
              <div className="card-header d-flex justify-content-between align-items-center">
                <div className="d-inline-flex align-items-center">
                  <span className="title-icon bg-soft-primary fs-16 me-2">
                    <i className="ti ti-shopping-cart" />
                  </span>
                  <h5 className="card-title mb-0">Posted &amp; Hired</h5>
                </div>
                <ul className="nav btn-group custom-btn-group">
                  <Link className="btn btn-outline-light" to="#">
                    1D
                  </Link>
                  <Link className="btn btn-outline-light" to="#">
                    1W
                  </Link>
                  <Link className="btn btn-outline-light" to="#">
                    1M
                  </Link>
                  <Link className="btn btn-outline-light" to="#">
                    3M
                  </Link>
                  <Link className="btn btn-outline-light" to="#">
                    6M
                  </Link>
                  <Link className="btn btn-outline-light active" to="#">
                    1Y
                  </Link>
                </ul>
              </div>
              <div className="card-body pb-0">
                <div>
                  <div className="d-flex align-items-center gap-2">
                    <div className="border p-2 br-8">
                      <p className="d-inline-flex align-items-center mb-1">
                        <i className="ti ti-circle-filled fs-8 text-primary-300 me-1" />
                        Jobs Posted
                      </p>
                      <h4>3K</h4>
                    </div>
                    <div className="border p-2 br-8">
                      <p className="d-inline-flex align-items-center mb-1">
                        <i className="ti ti-circle-filled fs-8 text-primary me-1" />
                        Canidates Hired
                      </p>
                      <h4>1K</h4>
                    </div>
                  </div>
                  <div id="sales-daychart">
                    <Chart
                      options={salesDayChart}
                      series={salesDayChart.series}
                      type="bar"
                      height={245}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xxl-4 col-md-6 d-flex">
            <div className="card flex-fill">
              <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-3">
                <div className="d-inline-flex align-items-center">
                  <span className="title-icon bg-soft-danger fs-16 me-2">
                    <i className="ti ti-alert-triangle" />
                  </span>
                  <h5 className="card-title mb-0">Upcoming Interviews</h5>
                </div>
                <Link
                  to={route.applicantTracking}
                  className="fs-13 fw-bold text-decoration-underline"
                >
                  View All
                </Link>
              </div>
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between mb-4">
                  <div className="d-flex align-items-center">
                    <Link to="#" className="avatar avatar-lg">
                      <img src="assets/img/products/product-06.jpg" alt="img" />
                    </Link>
                    <div className="ms-2">
                      <h6 className="fw-bold mb-1">
                        <Link to="#">Chaitanya</Link>
                      </h6>
                      <p className="fs-13">ID : #665814</p>
                    </div>
                  </div>
                  <div className="text-end">
                    <p className="fs-13 mb-1">MS companies</p>
                    <h6 className="text-orange fw-bold">
                      12-Jan-2025 11:50 AM
                    </h6>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between mb-4">
                  <div className="d-flex align-items-center">
                    <Link to="#" className="avatar avatar-lg">
                      <img src="assets/img/products/product-07.jpg" alt="img" />
                    </Link>
                    <div className="ms-2">
                      <h6 className="fw-bold mb-1">
                        <Link to="#">Raju</Link>
                      </h6>
                      <p className="fs-13">ID : #940004</p>
                    </div>
                  </div>
                  <div className="text-end">
                    <p className="fs-13 mb-1">larvel & Co</p>
                    <h6 className="text-orange fw-bold">
                      17-Jan-2025 08:00 PM
                    </h6>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between mb-4">
                  <div className="d-flex align-items-center">
                    <Link to="#" className="avatar avatar-lg">
                      <img src="assets/img/products/product-08.jpg" alt="img" />
                    </Link>
                    <div className="ms-2">
                      <h6 className="fw-bold mb-1">
                        <Link to="#">Ram</Link>
                      </h6>
                      <p className="fs-13">ID : #325569</p>
                    </div>
                  </div>
                  <div className="text-end">
                    <p className="fs-13 mb-1">Insights & Co</p>
                    <h6 className="text-orange fw-bold">
                      25-Jan-2025 02:15 AM
                    </h6>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between mb-4">
                  <div className="d-flex align-items-center">
                    <Link to="#" className="avatar avatar-lg">
                      <img src="assets/img/products/product-09.jpg" alt="img" />
                    </Link>
                    <div className="ms-2">
                      <h6 className="fw-bold mb-1">
                        <Link to="#">Venkatesh</Link>
                      </h6>
                      <p className="fs-13">ID : #124588</p>
                    </div>
                  </div>
                  <div className="text-end">
                    <p className="fs-13 mb-1">ABC solutions</p>
                    <h6 className="text-orange fw-bold">
                      30-Jan-2025 05:40 PM
                    </h6>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between mb-0">
                  <div className="d-flex align-items-center">
                    <Link to="#" className="avatar avatar-lg">
                      <img src="assets/img/products/product-10.jpg" alt="img" />
                    </Link>
                    <div className="ms-2">
                      <h6 className="fw-bold mb-1">
                        <Link to="#">Jacob</Link>
                      </h6>
                      <p className="fs-13">ID : #365586</p>
                    </div>
                  </div>
                  <div className="text-end">
                    <p className="fs-13 mb-1">Intel solutions</p>
                    <h6 className="text-orange fw-bold">
                      10-Feb-2025 03:05 AM
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-header">
            <h4 className="card-title">Latest Jobs Posted</h4>
          </div>
          <div className="card-body">
            <div className="table-responsive dataview">
              <table className="table dashboard-expired-products">
                <thead className="thead-light">
                  <tr>
                    <th>Company</th>
                    <th>Designation</th>
                    <th>Job Location</th>
                    <th>Apply by</th>
                    <th>Interview Date</th>
                    <th className="no-sort">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div className="d-flex align-items-center">
                        <Link to="#" className="avatar avatar-lg me-2">
                          <ImageWithBasePath
                            src="assets/img/products/expire-product-01.png"
                            alt="product"
                          />
                        </Link>
                        <Link to="#" className="fw-bold">
                          GlobalCorp Industries
                        </Link>
                      </div>
                    </td>
                    <td>Sales Executive</td>
                    <td>Cape Town, South Africa</td>
                    <td>17 Jan 2023</td>
                    <td>29 Mar 2023</td>
                    <td className="action-table-data">
                      <div className="edit-delete-action">
                        <Link className="me-2 p-2" to="#">
                          <i data-feather="edit" className="feather-edit" />
                        </Link>
                        <Link className=" confirm-text p-2" to="#">
                          <i
                            data-feather="trash-2"
                            className="feather-trash-2"
                          />
                        </Link>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="d-flex align-items-center">
                        <Link to="#" className="avatar avatar-lg me-2">
                          <ImageWithBasePath
                            src="assets/img/products/expire-product-02.png"
                            alt="product"
                          />
                        </Link>
                        <Link to="#" className="fw-bold">
                          TechNova Solutions
                        </Link>
                      </div>
                    </td>
                    <td>Graphic Designer</td>
                    <td>Berlin, Germany</td>
                    <td>22 Feb 2023</td>
                    <td>04 Apr 2023</td>
                    <td className="action-table-data">
                      <div className="edit-delete-action">
                        <Link className="me-2 p-2" to="#">
                          <i data-feather="edit" className="feather-edit" />
                        </Link>
                        <Link className="confirm-text p-2" to="#">
                          <i
                            data-feather="trash-2"
                            className="feather-trash-2"
                          />
                        </Link>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="d-flex align-items-center">
                        <Link to="#" className="avatar avatar-lg me-2">
                          <ImageWithBasePath
                            src="assets/img/products/expire-product-03.png"
                            alt="product"
                          />
                        </Link>
                        <Link to="#" className="fw-bold">
                          Apex Innovations
                        </Link>
                      </div>
                    </td>
                    <td>Data Analyst</td>
                    <td>Toronto, Canada</td>
                    <td>18 Mar 2023</td>
                    <td>13 May 2023</td>
                    <td className="action-table-data">
                      <div className="edit-delete-action">
                        <Link className="me-2 p-2" to="#">
                          <i data-feather="edit" className="feather-edit" />
                        </Link>
                        <Link className=" confirm-text p-2" to="#">
                          <i
                            data-feather="trash-2"
                            className="feather-trash-2"
                          />
                        </Link>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="d-flex align-items-center">
                        <Link to="#" className="avatar avatar-lg me-2">
                          <ImageWithBasePath
                            src="assets/img/products/expire-product-04.png"
                            alt="product"
                          />
                        </Link>
                        <Link to="#" className="fw-bold">
                          Woodcraft Sandal
                        </Link>
                      </div>
                    </td>
                    <td>Marketing Manager</td>
                    <td>New York, USA</td>
                    <td>29 Mar 2023</td>
                    <td>27 May 2023</td>
                    <td className="action-table-data">
                      <div className="edit-delete-action">
                        <Link className="me-2 p-2" to="#">
                          <i data-feather="edit" className="feather-edit" />
                        </Link>
                        <Link className=" confirm-text p-2" to="#">
                          <i
                            data-feather="trash-2"
                            className="feather-trash-2"
                          />
                        </Link>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="d-flex align-items-center">
                        <Link to="#" className="avatar avatar-lg me-2">
                          <ImageWithBasePath
                            src="assets/img/products/stock-img-03.png"
                            alt="product"
                          />
                        </Link>
                        <Link to="#" className="fw-bold">
                          Horizon Technologies
                        </Link>
                      </div>
                    </td>
                    <td>Software Engineer</td>
                    <td>Paris, France</td>
                    <td>24 Mar 2023</td>
                    <td>26 May 2023</td>
                    <td className="action-table-data">
                      <div className="edit-delete-action">
                        <Link className="me-2 p-2" to="#">
                          <i data-feather="edit" className="feather-edit" />
                        </Link>
                        <Link className=" confirm-text p-2" to="#">
                          <i
                            data-feather="trash-2"
                            className="feather-trash-2"
                          />
                        </Link>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApplicantTracking;
